import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from 'components/Page/Dashboard';
import TournamentDate from 'components/Play/Tournament/Edit/TournamentDate';

const Step3 = ({ match }) => (
  <Page showNavigation={false}>
    <TournamentDate edit={match.path.includes('edit')} />
  </Page>
);

Step3.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Step3);
